import React, { Component } from "react";
import PubSub from "pubsub-js";
import { css } from "emotion";
import { Dropdown, Input } from "@maxmilhas/hangar-components-atomic/public";
import { item } from "./style";

import "../../../shared/pubsub-triggers";

class TripTimeDropdown extends Component {
  state = {
    selectedTime: []
  }
  
  constructor(props) {
    super(props);
    this.handleToggleCheck = this.handleToggleCheck.bind(this);
  }

  handleToggleCheck(event) {
    let arr = [ ...this.state.selectedTime ];

    if (event.target.checked) {
      PubSub.publish("dataLayer", {
        event: "gaEvent",
        gaEventCategory: "Ponte aérea max",
        gaEventAction: "Quais datas planeja viajar",
        gaEventLabel: `Interação com Horário de ${this.props.direction === "outbound" ? "ida" : "volta"}`,
        gaEventDetail: event.target.parentElement.querySelector("label").innerText
      });
    }

    if (event.target.value === "all") {
      arr = [];
    } else {
      const idx = arr.indexOf(event.target.value);

      if (idx === -1) {
        arr.push(event.target.value);
      } else {
        arr.splice(idx, 1);
      }
    }
    
    this.setState({ selectedTime: arr.sort() });

    if (this.props.onChange) {
      this.props.onChange(arr.sort());
    }
  }

  formatTimes(ga = false) {
    const { selectedTime } = this.state;
    
    if (selectedTime.length === 0) {
			return ga ? "Horário (Todos)" : "Todos";
		}

		const timesName = [];

		if (selectedTime.indexOf("dawn") !== -1) {
			timesName.push(ga ? "Horário (Madrugada)" : "Madrugada");
		}

		if (selectedTime.indexOf("morning") !== -1) {
			timesName.push(ga ? "Horário (Manhã)" : "Manhã");
		}

		if (selectedTime.indexOf("afternoon") !== -1) {
			timesName.push(ga ? "Horário (Tarde)" : "Tarde");
		}

		if (selectedTime.indexOf("night") !== -1) {
			timesName.push(ga ? "Horário (Noite)" : "Noite");
		}

		return timesName.length === 4 ? (ga ? "Horário (Todos)" : "Todos") : timesName.join(", ");
	}
  
  render() {
    const { id } = this.props;
    const { selectedTime } = this.state;
    
    return (
      <Dropdown shadow={true} label="Horário" text={this.formatTimes()} role="group" aria-label="Filtrar por horário">
          <div className={css`${item}`}>
              <Input
                id={`${id}-dawn`}
                type="checkbox"
                value="dawn"
                label="Madrugada"
                checked={selectedTime.includes("dawn")}
                onChange={this.handleToggleCheck} />
          </div>
          <div className={css`${item}`}>
              <Input
                id={`${id}-morning`}
                type="checkbox"
                value="morning"
                label="Manhã"
                checked={selectedTime.includes("morning")}
                onChange={this.handleToggleCheck} />
          </div>
          <div className={css`${item}`}>
              <Input
                id={`${id}-afternoon`}
                type="checkbox"
                value="afternoon"
                label="Tarde"
                checked={selectedTime.includes("afternoon")}
                onChange={this.handleToggleCheck} />
          </div>
          <div className={css`${item}`}>
              <Input
                id={`${id}-night`}
                type="checkbox"
                value="night"
                label="Noite"
                checked={selectedTime.includes("night")}
                onChange={this.handleToggleCheck} />
          </div>
          <div className={css`${item}`}>
              <Input
                id={`${id}-all`}
                type="checkbox"
                value="all"
                label="Todos"
                checked={selectedTime.length === 0}
                onChange={this.handleToggleCheck} />
          </div>
      </Dropdown>
    );
  }
}

export default TripTimeDropdown;